import React from 'react';
import { Document } from '../../../../graphql/graphql';
import CSSZSickLeaveCertificateDetailSubmissionItem from './CSSZSickLeaveCertificateDetailSubmissionItem';
import styles from './CSSZSickLeaveCertificateDetailSubmissions.module.scss';

interface Props {
	submissions: Document[];
}

const CSSZSickLeaveCertificateDetailSubmissions = ({ submissions }: Props) => {
	return (
		<div className={styles.wrapper}>
			{submissions.map(submission => (
				<CSSZSickLeaveCertificateDetailSubmissionItem
					key={submission.id}
					submission={submission}
				/>
			))}
		</div>
	);
};

export default CSSZSickLeaveCertificateDetailSubmissions;
